import { DateUtils } from './date';

export const dateUtils = new DateUtils();
